import { render, staticRenderFns } from "./AdditionalNotes.vue?vue&type=template&id=d0883c8c&"
import script from "./AdditionalNotes.vue?vue&type=script&lang=js&"
export * from "./AdditionalNotes.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalNotes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports